import api, { getLinks } from '../api';

export const SCHEDULED_STATUSES_FETCH_REQUEST = 'SCHEDULED_STATUSES_FETCH_REQUEST';
export const SCHEDULED_STATUSES_FETCH_SUCCESS = 'SCHEDULED_STATUSES_FETCH_SUCCESS';
export const SCHEDULED_STATUSES_FETCH_FAIL    = 'SCHEDULED_STATUSES_FETCH_FAIL';

export const SCHEDULED_STATUSES_EXPAND_REQUEST = 'SCHEDULED_STATUSES_EXPAND_REQUEST';
export const SCHEDULED_STATUSES_EXPAND_SUCCESS = 'SCHEDULED_STATUSES_EXPAND_SUCCESS';
export const SCHEDULED_STATUSES_EXPAND_FAIL    = 'SCHEDULED_STATUSES_EXPAND_FAIL';

export const SCHEDULED_STATUS_DELETE_SUCCESS = 'SCHEDULED_STATUS_DELETE_SUCCESS';

export const SCHEDULED_STATUS_UPDATE_SUCCESS = 'SCHEDULED_STATUS_UPDATE_SUCCESS';

export const fetchScheduledStatuses = () => (dispatch, getState) => {
  if (getState().getIn(['scheduled_statuses', 'isLoading'])) {
    return;
  }

  dispatch({ type: SCHEDULED_STATUSES_FETCH_REQUEST });

  api().get('/api/v1/scheduled_statuses', { params: { limit: 40 } }).then(response => {
    const next = getLinks(response).refs.find(link => link.rel === 'next');
    dispatch({
      type: SCHEDULED_STATUSES_FETCH_SUCCESS,
      statuses: response.data,
      next: next ? next.uri : null,
    });
  }).catch(error => {
    dispatch({ type: SCHEDULED_STATUSES_FETCH_FAIL, error });
  });
};

export const expandScheduledStatuses = () => (dispatch, getState) => {
  const url = getState().getIn(['scheduled_statuses', 'next']);

  if (!url || getState().getIn(['scheduled_statuses', 'isLoading'])) {
    return;
  }

  dispatch({ type: SCHEDULED_STATUSES_EXPAND_REQUEST });

  api().get(url).then(response => {
    const next = getLinks(response).refs.find(link => link.rel === 'next');
    dispatch({
      type: SCHEDULED_STATUSES_EXPAND_SUCCESS,
      statuses: response.data,
      next: next ? next.uri : null,
    });
  }).catch(error => {
    dispatch({ type: SCHEDULED_STATUSES_EXPAND_FAIL, error });
  });
};

export const deleteScheduledStatus = (id) => (dispatch) => {
  api().delete(`/api/v1/scheduled_statuses/${id}`).then(() => {
    dispatch({ type: SCHEDULED_STATUS_DELETE_SUCCESS, id });
  }).catch(() => {
    // ignore; the item stays in the list on failure
  });
};

// Edits a queued scheduled post (content and/or reschedule). Resolves the
// promise so callers can close the editor on success and surface errors.
export const updateScheduledStatus = (id, params) => (dispatch) =>
  api().put(`/api/v1/scheduled_statuses/${id}`, params).then(response => {
    dispatch({ type: SCHEDULED_STATUS_UPDATE_SUCCESS, status: response.data });
    return response.data;
  });
